import type { AccmeasureMongoDTO } from '../../dto/plc/acc-measure-mongo-dto'
import type { DynamicSensorReading } from '../../types/plc/dynamic-sensor-reading'

const mapToDynamicSensoreReading = (dto: AccmeasureMongoDTO): DynamicSensorReading => {
    return {
        xValue: dto.accX,
        yValue: dto.accY,
        zValue: dto.accZ,
        timestamp: dto.timestamp,
    }
}

const mapToAccMeasureDTO = (sensor: DynamicSensorReading): AccmeasureMongoDTO => {
    return {
        accX: sensor.xValue,
        accY: sensor.yValue,
        accZ: sensor.zValue,
        timestamp: sensor.timestamp,
    }
}

export { mapToDynamicSensoreReading, mapToAccMeasureDTO }
